<mat-card appearance="outlined" id="top">
  <mat-card-header>
    <mat-card-title>
      {{ 'COMMON.LINE_ITEMS.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>

  @if ((useInventoryItemPricingTableSelector$ | async) === true) {
    <ng-container *ngIf="editing">
      @if ((loading$ | async) === false) {
        <ng-container *ngTemplateOutlet="inventoryPricingTableSelector" />
      } @else {
        <ng-content *ngTemplateOutlet="loadingShimmer"></ng-content>
      }
    </ng-container>
  } @else {
    <mat-card-content>
      <ng-container *ngIf="loading$ | async">
        <div class="stencil-shimmer"></div>
        <div class="stencil-shimmer total-shimmer"></div>
      </ng-container>
      <div [hidden]="loading$ | async">
        <ng-container *ngIf="uiLineItems$ | async">
          <div *ngIf="!editing; else editingTemplate"></div>
        </ng-container>
      </div>
    </mat-card-content>
  }

  <ng-template #loadingShimmer>
    <div class="stencil-shimmer"></div>
    <div class="stencil-shimmer total-shimmer"></div>
  </ng-template>

  <ng-template #editingTemplate>
    <div class="form" *ngIf="currentLineItems && currentLineItems?.length > 0; else addItemsButton">
      <div class="table-container" *ngIf="(useInventoryItemPricingTableSelector$ | async) === false">
        <div class="table-wrapper">
          <!-- Header -->

          <!-- This should be changed to using a regular html table instead of mat-grid-list -->

          <mat-grid-list cols="24" rowHeight="40px">
            <mat-grid-tile [colspan]="11" [rowspan]="1">
              <mat-grid-tile-header style="place-content: center flex-start">
                {{ 'COMMON.LINE_ITEMS.ITEM' | translate }}
              </mat-grid-tile-header>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="3" [rowspan]="1">
              <mat-grid-tile-header style="place-content: center flex-end">
                {{ 'COMMON.LINE_ITEMS.QUANTITY' | translate }}
              </mat-grid-tile-header>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="5" [rowspan]="1">
              <mat-grid-tile-header style="place-content: center flex-end">
                {{ 'COMMON.LINE_ITEMS.UNIT_PRICE' | translate }}
              </mat-grid-tile-header>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="4" [rowspan]="1">
              <mat-grid-tile-header style="place-content: center flex-end">
                {{ 'COMMON.LINE_ITEMS.FREQUENCY' | translate }}
              </mat-grid-tile-header>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="1" [rowspan]="1"></mat-grid-tile>
          </mat-grid-list>

          <!-- Line Item Display -->
          <mat-grid-list *ngFor="let uiLineItem of currentLineItems; let liIndex = index" cols="24" rowHeight="48px">
            <div *ngIf="formArrayLineItems.controls[liIndex]" [formGroup]="formArrayLineItems.controls[liIndex]">
              <div
                *ngFor="
                  let revenueComponent of uiLineItem.lineItem?.currentRevenue?.revenueComponents || [];
                  let rcIndex = index
                "
              >
                <mat-grid-tile [colspan]="11" [rowspan]="1">
                  <div class="item-branding">
                    <div class="dual-icon" *ngIf="!!uiLineItem.parentName; else notAddon">
                      <va-icon [iconUrl]="uiLineItem.iconUrl" [iconName]="uiLineItem.name" [diameter]="30"></va-icon>
                      <va-icon
                        class="secondary-icon"
                        [iconUrl]="uiLineItem.parentIconUrl"
                        [diameter]="15"
                        [iconName]="uiLineItem.parentName"
                      ></va-icon>
                    </div>
                    <ng-template #notAddon>
                      <va-icon
                        class="icon"
                        [iconUrl]="uiLineItem.iconUrl"
                        [iconName]="uiLineItem.name"
                        [diameter]="30"
                      ></va-icon>
                    </ng-template>
                    <div class="item-name">
                      <span>{{ uiLineItem.name }}</span>
                      <span *ngIf="uiLineItem.editionName">| {{ uiLineItem.editionName }}</span>
                    </div>
                  </div>
                </mat-grid-tile>

                <mat-grid-tile [colspan]="3" [rowspan]="1">
                  <glxy-form-field
                    class="quantity"
                    [showLabel]="false"
                    [size]="'small'"
                    [bottomSpacing]="'none'"
                    [matTooltip]="
                      uiLineItem.isMultiActivatable && !uiLineItem.usesCustomPricing
                        ? ''
                        : ('COMMON.LINE_ITEMS.QUANTITY_DISABLED' | translate)
                    "
                  >
                    <input matInput type="number" formControlName="quantity" />
                  </glxy-form-field>
                  <mat-error *ngIf="formArrayLineItems.controls[liIndex]['controls'].quantity.hasError('min')">
                    {{ 'COMMON.LINE_ITEMS.GREATER_THAN_ZERO' | translate }}
                  </mat-error>
                </mat-grid-tile>

                <div
                  [formGroup]="formArrayLineItems.controls[liIndex]['controls']?.revenueComponents.controls[rcIndex]"
                >
                  <mat-grid-tile [colspan]="5" [rowspan]="1">
                    <glxy-form-field
                      class="unit-price"
                      [prefixText]="currencySymbol(uiLineItem.lineItem?.currencyCode)"
                      [showLabel]="false"
                      [size]="'small'"
                      [bottomSpacing]="'none'"
                    >
                      <input matInput formControlName="revenue" required />
                    </glxy-form-field>
                    <mat-error
                      *ngIf="
                        formArrayLineItems.controls[liIndex]['controls']?.revenueComponents.controls[
                          rcIndex
                        ].controls.revenue.hasError('required')
                      "
                    >
                      {{ 'COMMON.LINE_ITEMS.REVENUE_REQUIRED' | translate }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        formArrayLineItems.controls[liIndex]['controls']?.revenueComponents.controls[
                          rcIndex
                        ].controls.revenue.hasError('min')
                      "
                    >
                      {{ 'COMMON.LINE_ITEMS.GREATER_THAN_OR_EQUAL_TO_ZERO' | translate }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        formArrayLineItems.controls[liIndex]['controls']?.revenueComponents.controls[
                          rcIndex
                        ].controls.revenue.hasError('pattern')
                      "
                    >
                      {{ 'COMMON.LINE_ITEMS.MUST_BE_NUM' | translate }}
                    </mat-error>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="4" [rowspan]="1">
                    <glxy-form-field
                      class="period dropdown-field"
                      [showLabel]="false"
                      [size]="'small'"
                      [bottomSpacing]="'none'"
                    >
                      <mat-select class="selected-revenue-period" formControlName="period">
                        <ng-container *ngIf="rcIndex === 0 || uiLineItem.lineItem.packageId">
                          <mat-option *ngFor="let option of periodOptions" [value]="option.value">
                            {{ option.label | translate }}
                          </mat-option>
                        </ng-container>
                        <ng-container *ngIf="rcIndex !== 0 && !uiLineItem.lineItem.packageId">
                          <mat-option *ngFor="let option of oneTimeOnlyOptions" [value]="option.value">
                            {{ option.label | translate }}
                          </mat-option>
                        </ng-container>
                      </mat-select>
                    </glxy-form-field>
                    <mat-error
                      *ngIf="
                        formArrayLineItems.controls[liIndex]['controls']?.revenueComponents.controls[
                          rcIndex
                        ].controls.period.hasError('required')
                      "
                    >
                      {{ 'COMMON.LINE_ITEMS.FREQUENCY_REQUIRED' | translate }}
                    </mat-error>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="1" [rowspan]="1">
                    <ng-container *ngIf="editable">
                      <mat-menu #lineItemMenu="matMenu">
                        <button mat-menu-item (click)="addRevenueRow(liIndex)">
                          {{ 'COMMON.LINE_ITEMS.ADD_ROW' | translate }}
                        </button>
                        <button mat-menu-item (click)="deleteRevenueRow(liIndex, rcIndex)">
                          {{ 'COMMON.LINE_ITEMS.REMOVE_ROW' | translate }}
                        </button>
                        <button mat-menu-item (click)="deleteLineItem(liIndex)">
                          {{ 'COMMON.LINE_ITEMS.REMOVE' | translate }}
                        </button>
                      </mat-menu>
                      <button mat-icon-button class="menu-button" [matMenuTriggerFor]="lineItemMenu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                    </ng-container>
                  </mat-grid-tile>
                </div>
              </div>
            </div>
          </mat-grid-list>
        </div>
      </div>
      <!-- Add Line Item -->
      <div *ngIf="editable" class="row row-gutters">
        <ng-container *ngTemplateOutlet="addItemsButton" />
      </div>
    </div>
  </ng-template>
</mat-card>

<ng-template #addItemsButton>
  <div class="col col-xs-12">
    <button
      type="button"
      color="primary"
      mat-stroked-button
      class="action-button"
      data-action="add-line-item"
      (click)="addLineItems()"
    >
      + {{ 'COMMON.LINE_ITEMS.ADD' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #inventoryPricingTableSelector>
  <ng-container *ngIf="itemPricingTableSelectorConfig$ | async as config">
    <inventory-ui-item-pricing-table-selector
      id="inventory-pricing-table-selector"
      [config]="config"
      [selectedItems]="currentLineItems | lineItemsToInventoryItems"
      (itemsChanged)="updateLineItemsFromInventoryLineItems($event)"
    />
  </ng-container>
</ng-template>
